import { ACTIVITY_STATUS } from '../constants/activityStatus';
import {
    APPOINTMENT_MODALITY,
    APPOINTMENT_CARD_STATUS,
    APPOINTMENT_STATUS,
    TAppointmentModality,
    TAppointmentCardStatus,
} from '../constants/appointmentModality';

export const APPOINTMENT_JOIN_WINDOW_MINUTES = 15;

export const getMinutesUntilAppointment = (date: string, time: string): number => {
    const appointmentDate = new Date(`${date}T${time}`);
    return Math.round((appointmentDate.getTime() - Date.now()) / 60000);
};

export const mapToCardStatus = (status: string | undefined, isTimeValid: boolean): TAppointmentCardStatus => {
    if (status === ACTIVITY_STATUS.COMPLETED) return APPOINTMENT_CARD_STATUS.COMPLETED;
    if (
        status === ACTIVITY_STATUS.MISSED ||
        status === ACTIVITY_STATUS.NO_SHOW ||
        status === ACTIVITY_STATUS.CANCELLED
    ) return APPOINTMENT_CARD_STATUS.MISSED;
    if (status === ACTIVITY_STATUS.SCHEDULED) {
        return isTimeValid ? APPOINTMENT_CARD_STATUS.UPCOMING : APPOINTMENT_CARD_STATUS.SCHEDULED;
    }
    return APPOINTMENT_CARD_STATUS.MISSED;
};

export const mapModalityToType = (modality: string): TAppointmentModality => {
    if (modality === APPOINTMENT_MODALITY.AT_HOME) return APPOINTMENT_MODALITY.AT_HOME;
    if (modality === APPOINTMENT_MODALITY.TELEASSISTANCE) return APPOINTMENT_MODALITY.TELEASSISTANCE;
    if(modality === APPOINTMENT_MODALITY.TELEVISITA) return APPOINTMENT_MODALITY.TELEVISITA
    return APPOINTMENT_MODALITY.ON_SITE;
};

export const mapHistoryStatusToCardStatus = (status: string): TAppointmentCardStatus => {
    if (status === APPOINTMENT_STATUS.COMPLETED) return APPOINTMENT_CARD_STATUS.COMPLETED;
    if (status === APPOINTMENT_STATUS.CANCELLED) return APPOINTMENT_CARD_STATUS.MISSED;
    return APPOINTMENT_CARD_STATUS.SCHEDULED;
};
